module.exports = __webpack_public_path__ + "static/stacked-area-ffea8ab64a727c5c5f516e319ffd6fdd.png";